(function(){
  if (window.__pyroUI) return; window.__pyroUI = true;
  function init(){
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    var vids = document.querySelectorAll('video[data-px-video]');
    vids.forEach(function(v){
      v.muted = true; v.setAttribute('playsinline','');
      var end = parseFloat(v.getAttribute('data-px-end'));
      if (end > 0) v.addEventListener('timeupdate', function(){ if (v.currentTime >= end) { v.currentTime = 0; v.play().catch(function(){}); } });
      if (reduce) { v.removeAttribute('autoplay'); v.pause(); }
    });
    if (!reduce && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(es){ es.forEach(function(e){ if (e.isIntersecting) { var p = e.target.play(); if (p && p.catch) p.catch(function(){}); } else { e.target.pause(); } }); }, {threshold: 0.15});
      vids.forEach(function(v){ io.observe(v); });
      var ro = new IntersectionObserver(function(es){ es.forEach(function(e){ if (e.isIntersecting) { e.target.classList.add('is-in'); ro.unobserve(e.target); } }); }, {threshold: 0.12});
      document.querySelectorAll('.px-rail .px-head, .px-cats .px-head, .px-cat, .px-reels .px-head, .px-statement__inner').forEach(function(el){ el.classList.add('px-reveal'); ro.observe(el); });
    }
    document.querySelectorAll('.px-rail').forEach(function(sec){
      var t = sec.querySelector('[data-px-track]'); if (!t) return;
      var step = function(){ var c = t.querySelector('.px-card'); return c ? (c.getBoundingClientRect().width + 16) * 2 : 400; };
      var n = sec.querySelector('[data-px-next]'), p = sec.querySelector('[data-px-prev]');
      if (n) n.addEventListener('click', function(){ t.scrollBy({left: step(), behavior: 'smooth'}); });
      if (p) p.addEventListener('click', function(){ t.scrollBy({left: -step(), behavior: 'smooth'}); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function(){ window.__pyroUI = false; init(); window.__pyroUI = true; });
})();
